import { createRootRoute } from '@tanstack/react-router'

import RootLayout from '@/layout/default.tsx'

export const Route = createRootRoute({
  component: RootLayout,
})
